import { Translate } from 'next-translate';

export default function getMediaDuration(seconds: number | string): {
  mediaDuration: string;
  translatableField: string;
} {
  const duration =
    typeof seconds === 'string' ? parseInt(seconds, 10) : seconds || 0;

  let mediaDuration;
  let translatableField;

  if (seconds >= 3600) {
    mediaDuration = new Date(duration * 1000).toISOString().substr(11, 5);
    translatableField = 'hours';
  } else if (seconds < 60) {
    mediaDuration = new Date(duration * 1000).toISOString().substr(17, 2);
    translatableField = 'seconds';
  } else {
    mediaDuration = new Date(duration * 1000).toISOString().substr(14, 5);
    translatableField = 'minutes';
  }

  return { mediaDuration, translatableField };
}

export function getTranslatedMediaDuration(seconds = 0, t: Translate): string {
  let duration;
  if (seconds >= 3600) {
    duration = new Date(seconds * 1000).toISOString().substr(11, 5);
    return `${duration} ${t('hours', { count: seconds })}`;
  } else if (seconds < 60) {
    duration = new Date(seconds * 1000).toISOString().substr(17, 2);
    return `${duration} ${t('seconds', { count: seconds })}`;
  } else {
    duration = new Date(seconds * 1000).toISOString().substr(14, 5);
    return `${duration} ${t('minutes', { count: seconds })}`;
  }
}
